import { Modal, Descriptions } from "antd";
import dayjs from "dayjs";

const UserDetailsModal = ({
  isModalOpen = false,
  setIsModalOpen = () => {},
  userDetailsData = {}
}) => {
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Modal
      title="View More"
      open={isModalOpen}
      footer={[]}
      onOk={handleOk}
      onCancel={handleCancel}
      width={2000}
    >
      <Descriptions bordered column={{ xs: 1, sm: 2 }}>
        <Descriptions.Item label="Name">{userDetailsData?.name || "--"}</Descriptions.Item>
        <Descriptions.Item label="College Name">
          {userDetailsData?.collegeName || "--"}
        </Descriptions.Item>
        <Descriptions.Item label="Discord Id">
          {userDetailsData?.discordNumId || "--"}
        </Descriptions.Item>
        <Descriptions.Item label="Discord Handle">
          {userDetailsData?.discordHandle || "--"}
        </Descriptions.Item>
        <Descriptions.Item label="Codeforces Id">
          {userDetailsData?.codeforcesId || "--"}
        </Descriptions.Item>
        <Descriptions.Item label="Registered On">
          {dayjs(userDetailsData?.registeredOn || "--").format("DD MMM YYYY | hh:mm")}
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};
export default UserDetailsModal;
